import { grades } from "data/grades";

const EXCLUDED_GRADE_VALUES = new Set(["Highered", "Gov"]);
const EDUCATOR_ONLY_ROLES = new Set(["Teacher", "OrganizationAdmin"]);

function getBaseGradeOptions() {
  return grades.filter((grade) => !EXCLUDED_GRADE_VALUES.has(grade.value));
}

export function getAllowedGradesForRole(role) {
  const baseGrades = getBaseGradeOptions();

  if (role === "Student") {
    return baseGrades.filter((grade) => grade.value !== "Educator");
  }

  if (EDUCATOR_ONLY_ROLES.has(role)) {
    return baseGrades.filter((grade) => grade.value === "Educator");
  }

  return baseGrades;
}

export function getFormikGradeOptionsForRole(role) {
  return getAllowedGradesForRole(role).map((grade) => ({
    key: grade.value,
    label: grade.label,
  }));
}

export function getGridGradeOptionsForRole(role) {
  return getAllowedGradesForRole(role).map((grade) => ({
    value: grade.value,
    label: grade.label,
  }));
}

export function getDefaultGradeLevelForRole(role) {
  if (EDUCATOR_ONLY_ROLES.has(role)) {
    return "Educator";
  }

  return "";
}

export function isGradeAllowedForRole(role, gradeLevel) {
  if (!gradeLevel) {
    return true;
  }

  return getAllowedGradesForRole(role).some(
    (grade) => grade.value === gradeLevel
  );
}
